import $ from "jquery";
import {CartProduct} from "./product";
import {CartDiscountCodeForm} from "./discount-code";
import {CheckoutForm} from "./checkout-form";

export class Cart {
    /**
     *
     * @param element string|HTMLElement
     */
    constructor (element) {
        let instance = this;
        this.mainCartElement = $(element);
        /** @type CheckoutForm|null */
        this.checkoutForm = null;
        this.products = [];

        this.totalElement = this.mainCartElement.find('.cart_total .price');
        this.shippingPriceElement = this.mainCartElement.find('.shipping_price .price');
        this.shippingPriceContainer = this.mainCartElement.find('.shipping_price');
        this.shippingPriceNextStepInfoElement = this.mainCartElement.find('.shipping_price_next_step_info');

        this.createDiscountCodeButton();

        this.mainCartElement.find('.discount_code_button a').on('click', this.onAddDiscountCodeClicked.bind(this));
        this.mainCartElement.find('.discount_code_row a').on('click', this.onRemoveDiscountCodeClicked.bind(this));

        this.miniCartElement = $('#mini-cart');
        if (this.totalElement.length > 0) {
            this.miniCartObserver = new IntersectionObserver(this.updateMiniCartVisible.bind(this));
            this.miniCartObserver.observe(this.totalElement[0]);
        }

        this.productsElements = $('.cart .product');
        this.productsElements.each(function() {
            const sku = $(this).data('product-sku');
            const miniElement = instance.miniCartElement.find('[data-product-sku=' + sku + ']');
            instance.products.push(new CartProduct(instance, this, miniElement));
        });

        this.upsaleButton = $('button.upsale-btn');
        if (this.upsaleButton.length > 0) {
            this.upsaleButton.on('click', this.onUpsaleButtonClicked.bind(this));
        }
    }

    createDiscountCodeButton() {
        this.discountCodeButton = this.mainCartElement.find('.discount_code_button');
        if (this.discountCodeButton.length > 0) {
            this.discountCodeModal = new CartDiscountCodeForm(this, $('#discount-code-modal'));
            this.discountCodeRows = this.mainCartElement.find('.discount_code_row');
        }
    }

    onAddDiscountCodeClicked(event) {
        event.preventDefault();
        this.discountCodeModal.open();
    }

    onRemoveDiscountCodeClicked(event) {
        event.preventDefault();
        this.mainCartElement.addClass('updating');

        const postData = {action: 'remove-discount-code'};
        if (this.checkoutForm) {
            this.checkoutForm.postFromCart(postData).then(res => this.onCartUpdateResponse(res));
        }
    }

    updateProductQuantity(sku, setTo) {
        this.mainCartElement.addClass('updating');

        const postData = {action: 'update', change: {}};
        postData['change'][sku] = setTo;
        if (this.checkoutForm) {
            this.checkoutForm.postFromCart(postData).then(res => this.onCartUpdateResponse(res));
        }
    }

    /**
     * @param code string
     * @returns {Promise<{accepted: boolean, applies: boolean}>}
     */
    async applyDiscountCode(code) {
        this.mainCartElement.addClass('updating');

        if (this.checkoutForm) {
            const postData = {action: 'apply-discount-code', code: code};
            const cartRes = await this.checkoutForm.postFromCart(postData);
            if (cartRes) {
                this.onCartUpdateResponse(cartRes);
                return {accepted: cartRes.discountCodeAccepted, applies: cartRes.discountApplies};
            }
        }
        return {accepted: false, applies: false};
    }

    getProductBySku(sku) {
        return this.products.find(obj => { return obj.sku === sku });
    }

    onCartUpdateResponse(res) {
        if (res.items) {
            for (const idx in res.items) {
                const item = res.items[idx];
                let product = this.getProductBySku(item.sku);
                if (product) {
                    product.updateFromServer(item);
                } else {
                    // console.log('got an update for a product ' + item.sku + ' that is not in the cart. Added from outside?');
                    window.location.reload();
                    return;
                }
            }
            const allItemsReceivedUpdates = this.products.length === res.items.length;
            if (!allItemsReceivedUpdates) {
                //console.log('an item in the cart did not receive update. Removed?');
                window.location.reload();
            }
        }
        this.totalElement.text(res.total);
        this.shippingPriceElement.text(res.shipping);

        this.shippingPriceNextStepInfoElement.toggleClass('hidden', res.shippingFl !== null);
        this.shippingPriceContainer.toggleClass('hidden', res.shippingFl === null);

        if (this.discountCodeButton != null) {
            this.discountCodeButton.toggleClass('hidden', res.hasDiscount);
        }
        if (this.discountCodeRows != null) {
            this.discountCodeRows.toggleClass('hidden', !res.hasDiscount);
        }

        this.mainCartElement.removeClass('updating');
    }

    updateMiniCartVisible(entries, observer) {
        this.miniCartElement.toggleClass('visible', ! entries[0].isIntersecting);
    }

    setShippingPrice(formattedPrice) {
        this.shippingPriceElement.text(formattedPrice);
    }

    /** @deprecated */
    selectShippingService(service) {
        if (this.checkoutForm) {
            const postData = {action: 'select-shipping-service', service: service};
            this.checkoutForm.postFromCart(postData).then(res => this.onCartUpdateResponse(res));
        }
    }

    async onUpsaleButtonClicked(event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        const newSku = button.data('new-sku');
        const oldSkus = button.data('old-sku');
        this.mainCartElement.addClass('updating');
        const postData = {action: 'upsale-replace-product', new: newSku, old: oldSkus};
        const cartRes = await this.checkoutForm.postFromCart(postData);
        if (cartRes) {
            this.onCartUpdateResponse(cartRes);
            return true;
        }
    }
}